import Bowser from 'bowser';

export const getPlatformType = () => {
  try {
    const { type: platformType } = Bowser.parse(window.navigator.userAgent).platform;
    return platformType || 'unknown';
  } catch (e) {
    return 'parsing-error';
  }
};
